import { BehaviorSubject } from "rxjs";
import { CoordinatorService } from "./coordinator.service";

export class Transformer$ {
    fieldMapping$ = new BehaviorSubject(undefined)    

    constructor(private coords: CoordinatorService) {}

}
